import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {getShoppingCarList, deleteShoppingCarList, addFavoritesList} from '../../service/favorites';
/*获取购物车列表,删除,加入收藏夹接口*/
import {proBigNameScreening} from '../../service/product';
import {Store, Actions} from './store';

class ShoppingCarList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['我的收藏夹'],
            key: 0,
            proBigName_type: [],
            selectedRowKeys: [],
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1,
                channelCode: this.channelData.split('|')[1] || ''
            },
            categoryData: [],
            item: [],
            productId: '',
            loading: true,
        };
        this.removeChange = this.removeChange.bind(this);
        this.addfFavorites = this.addfFavorites.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys, item) => {

        var selectitems = this.state.item;

        var items = [];

        item.forEach((key, i) => {

            var flag = true;

            selectitems.forEach((k, z) => {
                if (k.id == item[i].id) {
                    flag = false;
                    return;
                }
            })
            if (flag) {
                selectitems.push(item[i]);
            }
        });

        selectitems.forEach((key, i) => {
            if (selectedRowKeys.indexOf(key.id) >= 0) {
                items.push(selectitems[i]);
            }
        });

        this.setState({selectedRowKeys, item: items});

    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*移出收藏夹*/
    removeChange(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要移出收藏夹的产品');
            return;
        }
        var _arr = [];
        item.forEach(ele => {
            _arr.push({productId: ele.productId});
        });

        let self = this;
        deleteShoppingCarList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '移出收藏夹成功', '');
                self.initData();
            } else {
                openNotice('error', '移出收藏夹失败', (result && result.message) ? result.message : '');
            }
        });
    };

    removeChange1(id) {
        var _arr = [];
        _arr.push({productId: id});
        let self = this;
        deleteShoppingCarList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '移出收藏夹成功', '');
                self.initData();
            } else {
                openNotice('error', '移出收藏夹失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*加入购物车*/
    addfFavorites(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要加入购物车的产品');
            return;
        }
        var _arr = [];
        item.forEach(ele => {
            _arr.push({
                productId: ele.productId,
                count: 1,
            });
        });
        let self = this;
        addFavoritesList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '加入购物车成功', '');
                self.initData();
            } else {
                openNotice('error', '加入购物车失败', (result && result.message) ? result.message : '');
            }
        });
    }

    /*筛选*/
    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '',
                category: [],
                active: '',
                productName: '',
                proLine: '',
                proBigName: '',
                itemNum: '',
                stockType: '',
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        self.setState({loading: true});
        getShoppingCarList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false,
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'shoppingCar') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                }
            });
        }
        proBigNameScreening().then(res => { //物料大类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                });
                this.setState({proBigName_type: arr},
                )
            }
        });
    };

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, proBigName_type, loading} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'productName',
                    label: '物料名称',
                    text: '输入物料名称',
                    type: 'default',
                    defaultValue: searchObj.productName
                },
                {
                    name: 'proLine',
                    label: '产品线',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.proLine || ''
                },
                {
                    name: 'proBigName',
                    label: '物料大类',
                    text: '选择物料大类',
                    options: proBigName_type,
                    multiple: false,
                    type: 'select',
                    showSearch: true,
                    defaultValue: searchObj.proBigName || []
                },
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'stockType',
                    label: '库存类型',
                    text: '选择库存类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '库存', text: '库存'},
                        {value: '非库存', text: '非库存'},
                        {value: '定制', text: '定制'},
                        {value: '专属定制', text: '专属定制'},
                        {value: '退市', text: '退市'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.stockType || ''
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'productName',
                    render: (text, record, index) => {
                        if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else {
                            return (<a href={`#/product/${record.productId}`} style={{whiteSpace: 'pre'}}>{text}</a>)
                        }
                    }

                },
                {
                    title: '物料大类',
                    dataIndex: 'proBigName',
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType'
                },
                {
                    title: '最小装箱数',
                    dataIndex: 'minOrderQuantity'
                },
                {
                    title: '最小起订量',
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                },
                {
                    title: '牌价',
                    dataIndex: 'promotionPrice'
                },
                {
                    title: '操作',
                    dataIndex: 'a',
                    render: (text, record, index) => {
                        return <Button style={{background: '#red'}}
                                       onClick={this.removeChange1.bind(this, record.productId)}>移除</Button>
                    }
                }

            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: record => ({
                    disabled: (record.itemManagerFlag == null || record.orderManagerFlag == null)
                })
            }
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.removeChange.bind(this, this.state.item)}>移出收藏夹</Button>
                    <Button style={{left: 8}} onClick={this.addfFavorites.bind(this, this.state.item)}>加入购物车</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default withRouter(ShoppingCarList);



// WEBPACK FOOTER //
// ./src/routes/favorites/list.js